// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const ChartIcon: MarkdocTagRegistration = {
  tag: 'chart-icon',
  component: 'ChartIcon',
  attributes: {
    icon: {type: String, required: true},
    color: {type: String},
    iconStyle: {type: String},
    size: {type: Number},
  },
};
